export const isSelected = (items, id) => {
  if (items.length === 0) {
    return null;
  }
  return items.some((i) => i.id === id);
};

export const getDateToday = () => {
  return (
    new Date().getFullYear() +
    "-" +
    ("0" + (new Date().getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + new Date().getDate()).slice(-2)
  );
};

export const isObjEmpty = (obj = {}) => {
  return Object.keys(obj).length === 0;
};

export const redirectTo = (url) => {
  const pdfWindow = window.open();
  return (pdfWindow.location.href = url);
};

export const isChecked = (contributor, payer) => {
  const contributorCheck = Object.values(contributor).some((e) => !e.checked);
  const payerCheck = Object.values(payer).some((e) => !e.checked);
  return payerCheck || contributorCheck;
};

export const getParam = (param) => {
  const url_string = window.location.href;
  const url = new URL(url_string);
  const value = url.searchParams.get(param);
  return value;
};

export const getInternalId = (contributor) => {
  return `${contributor["cuit"]}_${Date.now()}`;
};
